let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6KDUv")).then(() => parcelRequire('iiqL3'));